<template>
  <div>
    <v-layout wrap>
      <v-flex>
        <v-layout wrap>
          <v-flex xs6 style="padding: 10px">
            <v-layout wrap>
              <v-flex xs6 style="padding-right: 10px">
                <i-datepicker
                    value=""
                    label="Từ ngày"
                    clearable
                    @clearText="clearFromDate"
                    @change="onChangeFromDate"
                />
              </v-flex>
              <v-flex xs6>
                <i-datepicker
                    value=""
                    label="Đến ngày"
                    clearable
                    @clearText="clearToDate"
                    @change="onChangeToDate"
                />
              </v-flex>
            </v-layout>
          </v-flex>

        </v-layout>
        <c-search-form :input-search-items="searchItems"
                       :form-name="formName"
                       :hiddenFields="hiddenFields"
                       model="searchForm" :fields="fields"
                       key-property="logId"
                       :search-url="searchUrl"
                       :accept-create="false"
                       :accept-delete="false"
                       :acceptExport="0"
                       :reload="reload"
                       form-type="intable"
        >
        </c-search-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import axios from "axios";
import CSearchForm from "../../../components/form/ManageForm";
import {message} from "@/shared/message";
import {promises as fs} from "fs";
import CTextbox from "@/components/form/Textbox";

export default {
  name: 'log-management',
  components: {CTextbox, CSearchForm},
  data: () => {
    return {
      formName: "Count Log Vinaphone",
      searchUrl: null,
      reload: 0,

      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "3%",
          sortable: false,
          headerStyle: "text-align:center"
        },
        {
          value: 'name',
          text: 'Tên sản phẩm',
          width: "10%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'totalUser',
          text: 'Thuê bao kích hoạt ',
          width: "10%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'interActiveCount',
          text: 'Thuê bao Có tương tác',
          width: "10%",
          sortable: false,
          headerStyle: "text-align:left"
        },

        {
          value: 'percentInterActiveCount',
          text: 'Thuê bao Có tương tác/ Tổng',
          width: "10%",
          sortable: false,
          headerStyle: "text-align:left"
        },
        {
          value: 'monthlyActiveUser',
          text: 'Monthly Active User',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },
        {
          value: 'timeAccessAverage',
          text: 'Thời gian truy cập trung bình 30 ngày',
          sortable: false,
          search: false,
          width: "5%",
          headerStyle: "text-align:center",
        },

      ],
      hiddenFields: {
        lstAccountId: "",
        fromDate: null,
        toDate: null,
      },
    }
  },
  methods: {
    onChangeFromDate(date) {
      this.hiddenFields.startDate = date;
      this.reload = Math.random()
    },
    onChangeToDate(date) {
      this.hiddenFields.endDate = date;
      this.reload = Math.random()
    },
    clearFromDate() {
      this.hiddenFields.startDate = new Date();
    },
    clearToDate() {
      this.hiddenFields.endDate = new Date();
    },

    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },
  created() {
    this.searchUrl = "/babiAccountClass/countVina?sortField=status,classId&";
  }

}
</script>
